module.exports = __webpack_public_path__ + "static/media/logo-black.7e10bd0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-black.svg
// module id = 347
// module chunks = 0